import { ReactNode, useEffect, useState } from 'react';
import Button from '../ui-components/Button';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { clearSelectedThreadMessage } from 'flow/actions/chat-actions';
import useScreenSize from 'flow/hooks/useScreenSize';
import { twMerge } from 'tailwind-merge';

interface ThreadMessagePageProps {
    header: string;
    footer?: ReactNode;
    threadList: ReactNode;
    mainChatMessage: ReactNode;
    messageCount: number;
}

const ThreadMessagePage = ({
    header,
    mainChatMessage,
    footer,
    threadList,
    messageCount,
}: ThreadMessagePageProps) => {
    const dispatch = useAppDispatch();
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const { width } = useScreenSize();

    useEffect(() => {
        setIsSmallScreen(width < 720);
    }, [width]);

    return (
        <div
            className={twMerge(
                'min-w-[400px] overflow-hidden',
                isSmallScreen
                    ? 'animate-slideInDialpad absolute z-50 size-full'
                    : 'max-w-[400px]',
            )}
        >
            <div className="flex size-full flex-col border-s bg-white pb-3">
                <div className="space-between flex h-16 w-full items-center justify-center border-b px-4 font-bold">
                    <header className="no-wrap w-full overflow-hidden text-ellipsis whitespace-nowrap">
                        {header}
                    </header>
                    <Button
                        iconKey="close"
                        onClick={() => {
                            dispatch(clearSelectedThreadMessage());
                        }}
                    />
                </div>
                <div className="py-3">{mainChatMessage}</div>
                <div className="relative w-full">
                    <div className="absolute start-0 top-1/2 z-0 h-[1px] w-full bg-gray-300" />
                    <div className="flex w-full items-center justify-center px-3">
                        <div className="relative flex items-center rounded-sm border border-gray-300 bg-white px-3 py-0.5">
                            <span className="text-xs font-bold text-gray-500">
                                {messageCount > 0 ? messageCount : 'No'} Replies
                            </span>
                        </div>
                    </div>
                </div>
                {threadList}
                <div className="px-3">{footer}</div>
            </div>
        </div>
    );
};

export default ThreadMessagePage;
